import React from "react";
import DropdownSelect from "../../../../components/finalForms/ui/inputs/dropdown/DropdownSelect";
import Buttons from "../../../../components/ui/button/Buttons";
import Label from "../../../../components/finalForms/ui/label/Label";
import Avatar from "../../../../components/ui/avatar/Avtar";
import Iconify from "../../../../layouts/components/iconify/iconify";

const MyTeamMembers = () => {
  return (
    <div>
      <div className="myteam-members">
        <Label labelName="Team Members" isRequired={true} />
        <div className="myteam-dropdown">
          <DropdownSelect placeholder={"Please Select Team Members"} />
          <div className="myteam-members-addbtn">
            <Buttons
              buttonTypeClassName="theme-btn"
              onClick={""}
              buttonText="Team Member"
              textWithIcon={true}
              iconName="material-symbols:add-rounded"
              fontIcon={true}
            />
          </div>
        </div>
      </div>
      <div className="myteam-members-list">
        <Label labelName="Planning Team :" />
        <div className="row">
          <div className="col-4">
            <div className="project-team-member-card">
              <div className="project-team-member-card__profile">
                <div className="project-top-bar">
                  <div className="avatar-sec" style={{ position: "relative" }}>
                    <Avatar alt={"Praful Desai"} size="medium" shape="circle" />
                    <div className="project-team-member-card__status active"></div>
                  </div>
                  <div className="name-sec">
                    <div className="project-team-member-card__username">
                      {"Praful Desai"}
                    </div>
                  </div>
                  <button
                    className="delete-icon"
                    title="DELETE"
                    onClick={() => alert("Delete")}
                  >
                    <Iconify icon="mingcute:delete-2-line" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyTeamMembers;
